<div>
    <button class="btn" (click)="clickButton()">
        <span>{{ title }}</span>
        <img src="/images/document.svg" alt="document">
    </button>
</div>